const COLORS = [
  'bg-brand-100 text-brand-700',
  'bg-emerald-100 text-emerald-700',
  'bg-amber-100 text-amber-700',
  'bg-rose-100 text-rose-700',
  'bg-violet-100 text-violet-700',
  'bg-cyan-100 text-cyan-700',
  'bg-orange-100 text-orange-700',
  'bg-teal-100 text-teal-700',
]

function hashCode(str) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i)
    hash |= 0
  }
  return Math.abs(hash)
}

export default function Avatar({ name, size = 'sm' }) {
  if (!name) return null
  const initials = name
    .replace(/^(Dr\.?|Mr\.?|Mrs\.?|Ms\.?)\s*/i, '')
    .split(/\s+/)
    .slice(0, 2)
    .map(w => w[0]?.toUpperCase())
    .join('')

  const color = COLORS[hashCode(name) % COLORS.length]
  const sizeClasses = size === 'lg' ? 'h-10 w-10 text-sm' : size === 'md' ? 'h-8 w-8 text-xs' : 'h-6 w-6 text-[10px]'

  return (
    <span className={`inline-flex items-center justify-center rounded-full font-semibold flex-shrink-0 ${color} ${sizeClasses}`}>
      {initials}
    </span>
  )
}
